module.exports = __webpack_public_path__ + "img/Participant-Training-Feedback.38546b40.jpg";